'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';
import { currencyFormatter } from '@/utils/formatters/currency';
import { getInstallmentCount } from '@/utils/consts/installment.consts';
import { cn } from '@/utils/cn-tw-merge';

interface InstallmentTermsProps {
  totalPrice: number;
  className?: string;
  containerClassName?: string;
  stacked?: boolean;
  dataTestId?: string;
}

export const InstallmentTerms = ({
  totalPrice,
  className,
  containerClassName,
  stacked = false,
  dataTestId = DataTestIdEnum.SEARCH_CARD_INSTALLMENT_TERMS,
}: InstallmentTermsProps) => {
  const installmentCount = getInstallmentCount(totalPrice);

  return (
    <div className={cn('bg-gray-100 h-12 flex items-center px-4 rounded-lg w-fit', containerClassName)}>
      <Typography
        variant={TypographyVariant.MEDIUM_BODY_TEXT}
        className={cn('font-normal text-gray-900', className)}
        data-testid={dataTestId}
      >
        <span className={cn('font-bold text-base', stacked && 'block leading-tight')}>
          {currencyFormatter(totalPrice)}
        </span>
        {' '}
        em até
        {' '}
        {installmentCount}
        x
      </Typography>
    </div>
  );
};
